

class Horario {
    constructor({
      id = null,
      nombre = '',
  
      hora_inicio = '',
      hora_fin = '',
     
     
    }) {
      this.id = id;
      this.nombre = nombre;
    
      this.hora_inicio = hora_inicio;
      this.hora_fin = hora_fin;



     
    }
  
    // Método para actualizar los datos de la empresa
    update(data) {
      Object.assign(this, data);
    }
  }
  
export default Horario;